import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class ImageSlide extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get header(){
    return get(this, '_header.value', '');
  }

  get background(){
    return get(this, '_background.value[0].url', '');
  }

  get image(){
    return get(this, '_image.value[0].url', '');
  }

  get text(){
    return get(this, '_text', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/ImageSlide.model.js